export const GA_MEASUREMENT_ID = "G-NFQ897FTW6";

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url: URL): void => {
  if (typeof window.gtag !== "function") {
    console.warn("Google Analytics gtag.js not loaded");
    return;
  }
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: url.pathname + url.search + url.hash, // Send full URL path including query and hash
  });
};

interface EventParams {
  action: string;
  category: string;
  label: string;
  value?: number;
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }: EventParams): void => {
  if (typeof window.gtag !== "function") {
    console.warn("Google Analytics gtag.js not loaded");
    return;
  }
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

// Declare gtag on the window object for TypeScript
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}
